export const getCurrentLanguage = (): "en" | "ar" => {
	const lang = document.documentElement.lang;

	if (!lang) return "en";

	return lang.startsWith("ar") ? "ar" : "en";
};
